import { Stage } from '@leprecoins/react-pixi';
import { useElementSize } from '@mantine/hooks';
import { Container } from '@pixi/react';
import { InteractiveElementBall } from '../interactive-element-ball';
import { InteractiveElementGates } from '../interactive-element-gates';
import { InteractiveElementGoalkeeper } from '../interactive-element-goalkeeper';
import { InteractiveElementMessage } from '../interactive-element-message';
import { InteractiveElementOnboardingPopover } from '../interactive-element-onboarding-popover';
import cls from './interactive-element.module.scss';

type InteractiveElementProps = {
	onMessageClose?: () => void;
};

export const InteractiveElement = ({ onMessageClose }: InteractiveElementProps) => {
	const { ref, width, height } = useElementSize();

	return (
		<InteractiveElementOnboardingPopover>
			<InteractiveElementMessage onClose={onMessageClose}>
				<div
					ref={ref}
					className={cls.interactiveElement}
				>
					<Stage
						id='interactive-element'
						width={width}
						height={height}
						options={{
							backgroundAlpha: 0,
							resolution: Math.min(window.devicePixelRatio * 2, 2.5),
						}}
					>
						<Container
							scale={width / 3784}
							x={width / 2}
							y={height / 1.8}
						>
							<InteractiveElementGates />
							<InteractiveElementGoalkeeper />
						</Container>
					</Stage>
					<InteractiveElementBall />
				</div>
			</InteractiveElementMessage>
		</InteractiveElementOnboardingPopover>
	);
};
